// A one-line "today's date" anchor for the Sayer chat prompts. Without it, none of the
// chat prompts told the model the current date, so it couldn't reason about deadlines,
// resolve relative phrases ("by next spring"), or propose a concrete resolution date
// (#3523). Both a human-readable form and the ISO form are given: the model reads the
// former and can echo the latter (the prompts ask for YYYY-MM-DD dates).
//
// `now` is injectable so tests are deterministic; production callers pass nothing and get
// the real current date.
export function todayAnchor(now = new Date()) {
  const iso = now.toISOString().slice(0, 10);
  const human = now.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  return `Today's date is ${human} (${iso}).`;
}
